import { ValiError } from 'valibot';

import { API } from '@/api';
import { fetcher, HTTPError, logger } from '@/services/fetcher';

import { type ShipTypeFiltersUpdateApi, shipTypesApiSchema } from '../../models';

const masterDataApi = fetcher.extend(() => ({ prefixUrl: `${API.MASTER_DATA_PUBLIC}` }));

export const fetchShipTypes = async (
  filters: ShipTypeFiltersUpdateApi,
  { signal }: { signal?: AbortController['signal'] } = {},
) => {
  try {
    return await masterDataApi.get('lookup-code/SHIPTYPE', { searchParams: filters, signal }).json(shipTypesApiSchema);
  } catch (error) {
    if (error instanceof ValiError || (error instanceof Error && error.name === 'ValiError')) {
      logger.warn('Validation error on ship types response', (error as ValiError<typeof shipTypesApiSchema>).issues);
    }
    if (error instanceof HTTPError) {
      logger.error(`Error: ${error.response.status}`);
    }
    throw error;
  }
};
